module.exports = __webpack_public_path__ + "static/img/diyim1.ed381ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/diyim1.png
// module id = uc7q
// module chunks = 5